const file =
{
    dimension : '{0}x{1}px' ,
    separator : ' - ',
    resized   : 'Optimisé' ,
    unknown   : 'Inconnu'
};

export default file ;